// extracted by mini-css-extract-plugin
module.exports = {"spinner":"shared-components-Loading-Loading__spinner--2l1FZ"};